import React from "react";
import ArtistDetail from "../ArtistDetail";
import VideoList from "../VideoList";

const Artist = ({ match }) => {
    const id = match.params.artistId;
    console.log(id);
    return (
        <div>
            <ArtistDetail 
                key={id}
                artistId={id}/>
            <VideoList/>
        </div>
    );
};

export default Artist;